<template>
  <ButtonComponent
    id="request_linkedin_login"
      :variant="$props.variant"
      :text="$props.text"
      :image="'https://cdn.systemico.net/abc/icons/linkedin.svg'"
      @click="loginWithGoogle()"
      class="text-left"
      style="display: inline; width:250px;">
    <img
        src="../../../../assets/images/logo__google.svg"
        alt="logotipo google"
      />
  </ButtonComponent>
  <!--../../../../assets/images/logo__google.svg-->
</template>
<script>
import ButtonComponent from './ButtonComponent.vue';
export default {
  name: 'ButtonLinkedInLogin',
  components:{
    ButtonComponent
  },
  props: {
    text: String,
    variant: String
  },
  methods: {
    loginWithGoogle(){
      // REDIRECT SITE
      window.location.href = 'href="/api/glogin/validate"';
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../variables.scss";
</style>
